import { http } from "Utils/http";
import { Form,  Row, Col, Modal } from "react-bootstrap";
import { useState, useEffect, useRef, useMemo} from "react";
import {useLocation } from 'react-router-dom';
import {store} from 'Store';
import {setGlobalErrorStatus} from 'Components/StatusHandling'
import { useDispatch } from "react-redux"
import { useNavigate} from 'react-router-dom';
import { ERROR_MESSAGES } from "Utils/constants";
import { TableauViz,  useTableauVizRef } from "@tableau/embedding-api-react";

var vizEl = null;

const TableauView = (props) => {
    //console.log(Workbook);
    //console.log(props);
    const navigate = useNavigate();
    //const t = window.tableau;
    let location = useLocation();
    var passedData = location.state;
    //console.log("PASSED DATA");

    var dispatch = useDispatch();
    const loginState = store.getState().loginInfo;
    const [isLoading, setIsLoading] = useState(true); 
    
    const [reportId, setReportId] = useState(props.reportId);
    const [viewUrl, setViewUrl] = useState(null);
    const [viewMap, setViewMap] = useState(null);
    const [scriptUrl, setScriptUrl] = useState(null);
    const [token, setToken] = useState(null);
    const [reportName, setReportName] = useState(null);
    const [defaultView, setDefaultView] = useState(null);
    const [activeSheet, setActiveSheet] = useState(null);
    
    //const [workbook, setWorkbook] = useState(null);
	const [load, setLoad] = useState(true);

    const [reportLink, setReportLink] = useState(null);
    const [src, setSrc] = useState(null);
    const [width, setWidth] = useState(800);
    const [height, setHeight] = useState(200);

    const [showTermsPopup, setShowTermsPopup] = useState(false);

    const ref = useRef(0);
    const vizRef = useTableauVizRef();

    useEffect(()=>{
        setReportId(props.reportId);
    },[props.reportId]);

    const rerender = useMemo(() => {
            return {
                reportId: reportId
            };
    }, [reportId]); // ✅ Only changes when roomId changes

    
    useEffect(() => {
      
        if(reportId!=null && viewMap!=null && viewUrl!=null){
            //console.log("VIZ - " + reportId)
        }
    }, [viewMap, viewUrl]); // Empty dependency array ensures the effect runs only once

     useEffect(() => {
        if(reportId!=null){
            setViewMap(null);
            loadReportView(reportId);
            setShowTermsPopup(true);
        }
    }, [rerender]);

    useEffect(() => {
        
        if(activeSheet!=null && viewMap!=null && viewUrl!=null){
            //console.log("active - " + activeSheet)
        }
    }, [activeSheet]); // Empty dependency array ensures the effect runs only once


    const getReportView = async (reportId) => {

        var url = '/api/interactiveReports/viewTaleauReport';
        const loginState = store.getState().loginInfo;
        var data = {
            reportId: reportId
        }

            return http.post(url, data, {
                headers: {
                    "Authorization": "Bearer " + loginState.token
                    //"Referrer-Policy": "strict-origin-when-cross-origin"
                }
            });
    }

    const logReportView = async (reportId, reportViewName) => {

        var url = '/api/interactiveReports/logTableauAccess';
        const loginState = store.getState().loginInfo;
        var data = {
            reportId: reportId,
            reportViewName: reportViewName
        }
        
        return http.post(url, data, {
            headers: {
                "Authorization": "Bearer " + loginState.token
            }
        });
    }

    const disposeViz = () => {
    }


	const handleFirstInteractive = () => {
	    //console.log("HERE");
	    // 1. Access the underlying TableauViz DOM element using the ref
	    const vizElement = ref.current; 
  	};


    function vizResize() {
        var tabViz = document.getElementById("tableauViz");
        var tabCon = document.getElementById("tableau-container");
    }

    const loadReportView = async (reportId) => {
        
        var reports = {};
        
        return getReportView(reportId).then((res) => {
            //console.log("getFormData ", res);
            if (res.status != 1) {
                setGlobalErrorStatus({
                    dispatch: dispatch,
                    popupData: {
                        visible: true,
                        title: ERROR_MESSAGES.DATA_ERROR.title,
                        msg: res.globalErrorMessageList[0],
                        showContactHelp: true
                    },
                    redirect: {
                        redirect: false,
                        redirectFirst: false,
                        path: "",
                        data: {}
                    }
                });
            }
            else {
                setReportName(res.data.reportName);
                setScriptUrl(res.data.jsString);
                setToken(res.data.token);
                setViewMap(res.data.viewMap);
                setReportLink(res.data.reportLink);
                setViewUrl((res.data.viewMap)[res.data.defaultView]);
                setDefaultView(res.data.defaultView);
                setActiveSheet(res.data.defaultView);
            }
            setLoad(false);
            return res;
        }).catch((error) => {
            //console.log("Error caught while loading data: " + error);

            setGlobalErrorStatus({
                dispatch: dispatch,
                popupData: {
                    visible: true,
                    title: ERROR_MESSAGES.DATA_ERROR.title,
                    msg: ERROR_MESSAGES.DATA_ERROR.message,
                    showContactHelp: true
                },
                redirect: {
                    redirect: false,
                    redirectFirst: false,
                    path: "",
                    data: {}
                },
                error: error
            });
        });
        
    };

    const handleSelectionChange = (e) => {
        //console.log(e.target.value);
        setActiveSheet(e.target.value);
        var viewU = viewMap[e.target.value];
        //setViewUrl(viewU);
        //console.log(vizEl);
        const dashboard = vizEl.workbook;
        switchToSheet(dashboard, e.target.value);
    }

   const logReportViewCall = async (reportId, sheetName) => {
        var temp = viewMap[sheetName].split("views/");
        // the view name is the part after the last "views/"
        var reportViewName = temp[temp.length - 1]; 
        //console.log('report view name: ' + reportViewName);
        //console.log('report id: ' + reportId);

        return logReportView(reportId, reportViewName).then((res) => {
            //console.log("getFormData ", res);

            return res;
        }).catch((error) => {
            //console.log("Error caught while loading data: " + error);

            setGlobalErrorStatus({
                dispatch: dispatch,
                popupData: {
                    visible: true,
                    title: ERROR_MESSAGES.DATA_ERROR.title,
                    msg: ERROR_MESSAGES.DATA_ERROR.message,
                    showContactHelp: true
                },
                redirect: {
                    redirect: false,
                    redirectFirst: false,
                    path: "",
                    data: {}
                },
                error: error
            });
        });
    };
    
    const switchToSheet = async (workbook, sheetName) => {
        //console.log(viz);
        if (workbook) {
            logReportViewCall(reportId, sheetName);
            //console.log('Activating sheet: ${sheetName}');
            //console.log(workbook);
            // Use the Workbook object's asynchronous method
            const r = await workbook.activateSheetAsync(sheetName)
                .then((res) => {
                    var dashboard = workbook.activeSheet;
                })
                .catch(err => console.error('Error activating sheet:', err));
        } else {
            //console.log('Workbook is not yet loaded.');
        }
    };

    return (

        <>
                    {viewMap!=null?
                        <>
                        
                        
                            <h2>{reportName}</h2>
                            {Object.entries(viewMap).length>1 && activeSheet!=null
                                ?
                                    <div className="mb-4">

                                    <Form.Group as={Row} className="g-0" controlId="reportDropdown">
                                        <Col className="d-flex align-items-center flex-wrap row-gap-2 gap-2">
                                            <Col 
                                                className="p-0"
                                                
                                                md={'auto'}
                                                xs={12}
                                            >
                                                <Form.Label 
                                                    className="mb-0"
                                                >
                                                    {<span className="me-2">Select Report View</span>}
                                                </Form.Label>
                                            </Col>
                                            <Col 
                                                md={'auto'}
                                                xs={12}
                                                className="fit-content"
                                            >
                                                <Form.Select
                                                    
                                                    //name="rows"
                                                    onChange={handleSelectionChange}
                                                  
                                                    className="fit-content"
                                                >
                                                    {
                                                        Object.entries(viewMap).map(([k,v])=> {
                                                            //console.log(viewMap);
                                                            return <option key={"sheetOption_" + k} value={k} selected={activeSheet == k ? true : false}>{k}</option>
                                                        })
                                                    }
                                                    
                                                </Form.Select>
                                            </Col>
                                        </Col>
                                    </Form.Group>

                                    
                                    </div>
                                :   null
                            }

                            {token!=null && viewUrl!=null ?
                            <TableauViz
                                src={viewUrl}
                                hideTabs={true}
                                ref={vizRef}
                                touchOptimize={true}

                                token= {token}
                                iframeAttributeStyle=""
                                iframeStyle="
                                    iframe {
                                        width:100% !important;
                                        border: none;
                                    }
                                "
                               
                                onTabSwitched={async (event) => {
                                    var size = vizEl.vizImpl.calculateLayoutSize();

                                    const dashboard = vizEl.workbook.activeSheet;
                                    
                                    vizEl.vizImpl.iframe.height=dashboard.size.maxSize.height + 27 ;

                                    setActiveSheet(event.detail.newSheetName);
                                    
                                }}
                                
                                onFirstInteractive={async (event) => {
                                    const { target: viz } = event;
                                    vizEl=viz;
                                    const dashboard = vizEl.workbook.activeSheet;
                                    logReportViewCall(reportId, activeSheet);
                                    
                                    var size = vizEl.vizImpl.calculateLayoutSize();
                                    vizEl.vizImpl.iframe.height=size.height + 17;

                                    window.addEventListener('resize', function(event) {
                                        vizEl.vizImpl.iframe.height=dashboard.size.maxSize.height + 27 ;
                                    }, true);
                                    
                                    const filters = await dashboard.getFiltersAsync();
                                }}
                                onvizloaderror={async (event)=> {
                                    //console.log(event);
                                }}
                                className="border p-4 m-0"
                            />
                            : null }

                        </> 
                    : null 
            }

        </>
       
    )
}

export default TableauView;